import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";

// @mui/material components
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";


export default function CustomTable({ ...props }) {
  const {
    tableHead,
    tableData,
    tableHeaderColor,
    hover,
   
  } = props;


  return (
    <div >
          <Table sx={{ /*minWidth: 650*/ }} aria-label="simple table"> 
        {tableHead !== undefined ? (
            <TableBody>
            <TableRow>
              {tableHead.map((prop, key) => {               
                return (
                  <TableCell key={key}>
                    {prop}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableBody>
        ) : null}
        <TableBody>
          {tableData.map((prop, key) => {
            var rowColor = "";
            var rowColored = false;
              if (prop.color !== undefined) {
                  rowColor = prop.color;
                  rowColored = true;
                  prop = prop.data;
              }
           
              if (prop.total) {
                  return (
                      <TableRow key={key} hover={hover} c>
                          <TableCell
                              colSpan={prop.colspan}
                          />
                          <TableCell>
                              Total
                          </TableCell>
                          <TableCell>
                              {prop.amount}
                          </TableCell>
                          {tableHead.length - (prop.colspan - 0 + 2) > 0 ? (
                              <TableCell
                                  colSpan={tableHead.length - (prop.colspan - 0 + 2)}
                              />
                          ) : null}
                      </TableRow>
                  );
              }

              if (prop.purchase) {
                  return (
                      <TableRow key={key} hover={hover} >
                          <TableCell colSpan={prop.colspan} />
                          <TableCell colSpan={prop.col.colspan}>
                              {prop.col.text}
                          </TableCell>
                      </TableRow>
                  );
              }

            return (
              <TableRow
                key={key}
                hover={hover}                
              >
                    {prop.map((prop, key) => {
                        return (
                            <TableCell key={key}>
                                {prop}
                            </TableCell>
                        );
                    })}
                </TableRow>
            );
          })}
         </TableBody>       
      </Table>
    </div>
  );
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray",
  hover: false,
  colorsColls: [],
  coloredColls: [], 
};

CustomTable.propTypes = {
  classes: PropTypes.object.isRequired,
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  // Of(PropTypes.arrayOf(PropTypes.node)) || Of(PropTypes.object),
  tableData: PropTypes.array,
  hover: PropTypes.bool,
  coloredColls: PropTypes.arrayOf(PropTypes.number),
  // Of(["warning","primary","danger","success","info","rose","gray"]) - colorsColls
  colorsColls: PropTypes.array,   
  // this will cause some changes in font
  tableShopping: PropTypes.bool
};
